// Configuração de ambiente
// Detecta automaticamente se está em produção ou desenvolvimento

// Verifica se está em produção (build) ou desenvolvimento (start)
const isProduction = process.env.NODE_ENV === 'production';
const isDevelopment = process.env.NODE_ENV === 'development';

// Configurações baseadas no ambiente
export const CONFIG = {
  // Base path para imagens (respeita a subpasta de deploy via PUBLIC_URL)
  IMAGE_BASE_PATH: `${process.env.PUBLIC_URL}/images`,
  
  // Base path para assets
  ASSET_BASE_PATH: isProduction ? '.' : '.',
  
  // Ambiente atual
  ENVIRONMENT: isProduction ? 'PRODUÇÃO' : 'DESENVOLVIMENTO',
  
  // Debug info
  DEBUG: {
    NODE_ENV: process.env.NODE_ENV,
    isProduction,
    isDevelopment,
    timestamp: new Date().toISOString()
  }
};

// Log para debug
console.log('🔧 Configuração de Ambiente:');
console.log('Ambiente:', CONFIG.ENVIRONMENT);
console.log('Base path das imagens:', CONFIG.IMAGE_BASE_PATH);
console.log('Base path dos assets:', CONFIG.ASSET_BASE_PATH);
console.log('Debug:', CONFIG.DEBUG);




